import axios from "axios";

class Uploader {
  constructor(config) {
    this.config = Object.assign(
      {
        endpoint: "",
        additional: null,
        fileFieldName: "file",
        fileName: undefined
      },
      config
    );
  }

  upload(file) {
    return axios.post(this.config.endpoint, this.formData(file));
  }

  formData(file) {
    let formData = new window.FormData();

    formData.append(
      this.config.fileFieldName,
      file,
      this.config.fileName ? this.config.fileName : undefined
    );

    if (this.config.additional) {
      for (let field in this.config.additional) {
        formData.append(field, this.config.additional[field]);
      }
    }

    return formData;
  }
}

export default Uploader;
